/**
 * Financing Calculator + Delivery Status updater
 * Uses native <dialog> with ::backdrop.
 * Listens to afterVariantChanged for price + delivery status updates.
 * Does NOT modify product-info.js.
 */
(function () {
  var APR = 0.0699;
  var MONTHLY_RATE = Math.pow(1 + APR, 1 / 12) - 1;
  var currentPrice = 0;

  function calcMonthly(priceInCents, months) {
    var principal = priceInCents / 100;
    if (months <= 0 || principal <= 0) return 0;
    if (MONTHLY_RATE === 0) return Math.ceil(principal / months);
    return Math.ceil(
      (principal * MONTHLY_RATE) / (1 - Math.pow(1 + MONTHLY_RATE, -months))
    );
  }

  function formatEuro(amount) {
    return amount.toLocaleString('de-DE') + '€';
  }

  function formatMoney(priceInCents) {
    return (priceInCents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function getMonths() {
    var slider = document.getElementById('fin-months');
    return slider ? parseInt(slider.value, 10) : 72;
  }

  function getModal() {
    return document.getElementById('financing-modal');
  }

  function updateFinancing() {
    var months = getMonths();
    var monthly = calcMonthly(currentPrice, months);
    var euroStr = formatEuro(monthly);
    var moneyStr = formatMoney(currentPrice);

    var els;
    els = document.querySelectorAll('[data-fin-rate]');
    for (var i = 0; i < els.length; i++) els[i].textContent = euroStr;
    els = document.querySelectorAll('[data-fin-product-price]');
    for (var i = 0; i < els.length; i++) els[i].textContent = moneyStr;
    els = document.querySelectorAll('[data-fin-months-display]');
    for (var i = 0; i < els.length; i++) els[i].textContent = months;
    els = document.querySelectorAll('[data-fin-monthly]');
    for (var i = 0; i < els.length; i++) els[i].textContent = euroStr;
  }

  /* --- Delivery status update from fetched HTML --- */
  function updateDeliveryStatus(html, sectionId) {
    var source = html.getElementById('delivery-status-' + sectionId);
    var dest = document.getElementById('delivery-status-' + sectionId);
    if (source && dest) {
      dest.innerHTML = source.innerHTML;
      if (source.classList.contains('hidden')) {
        dest.classList.add('hidden');
      } else {
        dest.classList.remove('hidden');
      }
    }
  }

  // --- Open ---
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-financing-open]')) {
      var modal = getModal();
      if (modal && modal.showModal) {
        updateFinancing();
        modal.showModal();
      }
    }
  });

  // --- Close ---
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-financing-close]')) {
      var modal = getModal();
      if (modal && modal.close) modal.close();
    }
    var modal = getModal();
    if (modal && modal.open && e.target === modal) {
      modal.close();
    }
  });

  // --- Slider ---
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'fin-months') {
      updateFinancing();
    }
  });

  // --- Variant change ---
  document.addEventListener('afterVariantChanged', function (e) {
    if (!e.detail) return;

    // Update financing price
    if (e.detail.variant && e.detail.variant.price) {
      currentPrice = e.detail.variant.price;
      updateFinancing();
    }

    // Update delivery status from the fetched section HTML
    // afterVariantChanged is dispatched by product-info.js after it fetches new section HTML
    // We need to re-fetch the section HTML to get the delivery status
    // Instead, we intercept the fetch by hooking into product-info's rendering
    if (e.detail.sectionId) {
      var productInfo = document.querySelector('product-info[data-section="' + e.detail.sectionId + '"]');
      if (productInfo) {
        var variantId = e.detail.variant ? e.detail.variant.id : '';
        var url = window.location.pathname + '?variant=' + variantId + '&section_id=' + e.detail.sectionId;
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var html = new DOMParser().parseFromString(text, 'text/html');
            updateDeliveryStatus(html, e.detail.sectionId);
          })
          .catch(function () {});
      }
    }
  });

  // --- Init ---
  function init() {
    var wrapper = document.querySelector('.financing-button-wrapper');
    if (wrapper) {
      currentPrice = parseInt(wrapper.dataset.productPrice, 10) || 0;
    }
    updateFinancing();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
